import { fetchAPI } from "./apiCore";

export const fetchConsentFormGroups = async () => {
  try {
    return await fetchAPI("biobank/consent-forms/grouped", "GET");
  } catch (error) {
    console.error("Error fetching grouped consent forms:", error);
    return [];
  }
};

export const saveConsentFormGroup = async (payload) => {
  try {
    return await fetchAPI("biobank/consent-forms/grouped", "PUT", {}, payload);
  } catch (error) {
    console.error("Error saving consent form group:", error);
    throw error;
  }
};

export const createConsentFormGroup = async (payload) => {
  try {
    return await fetchAPI("biobank/consent-forms/grouped", "POST", {}, payload);
  } catch (error) {
    console.error("Error creating consent form group:", error);
    throw error;
  }
};

export const deleteConsentForm = async (consentFormId) => {
  try {
    return await fetchAPI(
      `biobank/consent-forms/${encodeURIComponent(consentFormId)}`,
      "DELETE"
    );
  } catch (error) {
    console.error("Error deleting consent form:", error);
    throw error;
  }
};
